import React from 'react';
import HeroSection from '../../../components/ProductsDetail/HeroSection';
import ProductShowcaseSection from '../../../components/ProductsDetail/ProductShowcaseSection';
import CTASection from '../../../components/ProductsDetail/CTASection';

// InfoBlocks
import {
  InfoSection,
  InstallGallery,
} from '../../../components/ProductsDetail/InfoBlocks';
import SectionDivider from '../../../components/ProductsDetail/SectionDivider';
import ProductDetailNav from '../../../components/ProductsDetail/ProductDetailNav';


const ExternalLightSign = () => {
  const installColumns = [
    {
      label: '주간',
      images: [
        '/images/products/signage/external-light-sign3.jpg',
      ],
    },
    {
      label: '야간',
      images: [
        '/images/products/signage/external-light-sign4.jpg',
      ],
    },
  ];


  

  return (
    <>
      <HeroSection
        title={`외부조명용 표지판`}
        subtitle={`야간 운전자의 시인성을 높여 안전운전을 돕습니다 `}
        backgroundImage="/images/products/signage/external-light-sign2.jpg"
        breadcrumbs={[
          { label: '홈', path: '/' },
          { label: '도로 안내표지시스템', path: '/products/signage' },
          { label: '외부조명용 표지판' },
        ]}
        categories={[
          { label: '도로 안전경보시스템', path: '/products/traffic-safety' },
          { label: '도로 안전유도시설', path: '/products/guardrail' },
          { label: '도로환경 개선시설', path: '/products/facilities' },
          { label: '도로 안내표지시스템', path: '/products/signage' },
        ]}
      />

      <ProductShowcaseSection
        subtitle={`야간에도 정확한 정보를 제공하는`}
        title={`외부조명용 표지판`}
        description={
          <>
            <strong>야간에도 정확한 도로 정보</strong>를 전달하기 위해 표지판 상단에 조명을 설치한 교통 안내 시설물로, {' '}
            운전자가 어두운 환경에서도 정보를 쉽게 확인할 수 있도록 <strong>시인성과 판독성을 강화</strong>하여 안전운전을 돕습니다.
            <br />
            <br />
            기존 표지판을 교체하지 않고 설치할 수 있어, 설치 및 유지보수 비용 절감되고 장기간 안정적인 운용으로 운영 효율성을 향상시킬 수 있습니다.
          </>
        }
        images={[
          '/images/products/signage/external-light-sign3.jpg',

        ]}
      />

      <SectionDivider />

      <InfoSection title="설치 사진">
        <InstallGallery columns={installColumns} />
      </InfoSection>

      

      <ProductDetailNav
        category="signage"
        currentPath="/products/signage/external-light-sign"
        listPath="/products/signage"
      />




      <CTASection />
    </>
  );
};

export default ExternalLightSign;
